/* global moment */
angular
  .module('statMember')
  .component('statMember', {
    template: require('./stat-member.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function StatMemberController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'member';
        $scope.selectedCityId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        // stat daily
        this.from_date = moment().startOf('month').format('YYYY-MM-DD');
        this.to_date = moment().endOf('month').format('YYYY-MM-DD');

        $scope.reloadDaily = () => {
          $resource(`${APIURL}/admin/stat/members/daily`).get({ from_date: this.from_date, to_date: this.to_date }).$promise.then((data) => {
            this.userCounts = data.userCounts;
            const total = this.userCounts.reduce((prev, cur) => {
              prev.NEW_USER_COUNT += cur.NEW_USER_COUNT;
              prev.NEW_USER_WITH_CODE += cur.NEW_USER_WITH_CODE;
              prev.NEW_USER_WITHOUT_CODE += cur.NEW_USER_WITHOUT_CODE;
              prev.NEW_USER_GENDER_M += cur.NEW_USER_GENDER_M;
              prev.NEW_USER_GENDER_F += cur.NEW_USER_GENDER_F;
              prev.NEW_USER_GENDER_U += cur.NEW_USER_GENDER_U;
              prev.FIRST_LOGIN += cur.FIRST_LOGIN;
              prev.FIRST_USAGE += cur.FIRST_USAGE;
              return prev;
            }, { NEW_USER_COUNT: 0, NEW_USER_WITH_CODE: 0, NEW_USER_WITHOUT_CODE: 0, NEW_USER_GENDER_M: 0, NEW_USER_GENDER_F: 0, NEW_USER_GENDER_U: 0, FIRST_LOGIN: 0, FIRST_USAGE: 0 });
            this.userCountsTotal = total;
          });
        };

        $scope.onDatePick = () => {
          console.log('onDatePick');
          this.from_date = jQuery('#inputPickerFrom').val();
          this.to_date = jQuery('#inputPickerTo').val();
          $scope.reloadDaily();
        };

        $scope.reloadDaily();

        // stat monthly
        $scope.pagingMonthly = (page) => {
          $resource(`${APIURL}/admin/stat/members/monthly`).get({ page }).$promise.then((data) => {
            console.log(data);
            this.countUserMonthly = data.countUserMonthly;
            this.userMonthly = data.userMonthly;
          });
        };
        $scope.pagingMonthly(0);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/stat-member/stat-member.component.js